import React from 'react';
import { Card, Button, Badge } from '@dopomogai/ui';
import type { InvestmentOfferingConfig, InvestmentStats } from '@dopomogai/types';

type Props = {
  agentId: string;
  offering: InvestmentOfferingConfig | null;
  stats?: InvestmentStats;
  onInvestClick?: (agentId: string) => void;
};

export function InvestTeaser({ agentId, offering, stats, onInvestClick }: Props) {
  if (!offering) return null;
  const active = offering.status === 'active';
  const sold = stats?.sold_shares ?? 0;
  const percent = Math.max(0, Math.min(100, Math.round((sold / Math.max(1, offering.total_shares)) * 100)));
  const remaining = Math.max(0, offering.total_shares - sold);

  return (
    <Card>
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <div className="font-extrabold">Investment</div>
          <Badge text={active ? 'Funding' : offering.status} accentColor={active ? 'green' : 'yellow'} />
        </div>
        <div className="w-full h-3 bg-slate-200 border-2 border-black rounded-lg overflow-hidden">
          <div className="h-full bg-emerald-400" style={{ width: `${percent}%` }} />
        </div>
        <div className="text-sm text-slate-700">{remaining} remaining • {offering.price_per_share_credits} cr/unit</div>
        <Button text={active ? 'Invest' : 'Funding closed'} disabled={!active} onClick={() => onInvestClick?.(agentId)} />
      </div>
    </Card>
  );
}


